import { sendTrackingEvent } from 'h-commons';
import { Typography, Dialog, DialogCloseButton, DialogTitle, DialogContent, DialogActions, Button, Tooltip, theme, icons } from '@hiver/hiver-ui-kit';

const ClosableModalStyles = {
    '& .MuiDialog-container': {
        backgroundColor: 'inherit',
        alignItems: 'center',
        justifyContent: 'center',
      },
    '& .modalTitle': {
        maxWidth: '90%'
    },
    '& .MuiTypography-root.MuiTypography-body2':{
        fontSize: theme.spacing(1.75),
        letterSpacing: 0,
    },
    '& .MuiPaper-root.MuiDialog-paper':{
        height: 'max-content',
        borderRadius: theme.spacing(1.5),
        padding:theme.spacing(3,)
    },
    '& .BlockingModalIcon':{
        padding: theme.spacing(2), 
        borderRadius: theme.spacing(2), 
        color: "#F07530", 
        background: theme.palette.orange.light,
    },
    '& .MuiDialogActions-root':{
        paddingTop: theme.spacing(1.5),
    }
}

export const ClosableModal = ({
    isOpen,
    title,
    description,
    btnText,
    onOk,
    showIcons,
    onClose,
    showBtn = true,
    styles = {},
    buttonSize='large',
    showCancelButton = false,
    buttonClickEvent = null,
}) => {
    const handleCTAClick = (event) => {
        if (buttonClickEvent) {
            sendTrackingEvent(buttonClickEvent);
        }
        onOk(event);
    }

    return (
        <Dialog open={isOpen} sx={{...ClosableModalStyles, ...styles}} >
            <DialogTitle>
                {showIcons && <icons.ErrorOutline className='BlockingModalIcon' />}
                <Typography className="modalTitle" variant="h2">{title}</Typography>
                <Tooltip title='Close' placement='bottom' arrow>
                    <DialogCloseButton onClick={onClose} />
                </Tooltip>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2">{description}</Typography>
            </DialogContent>
            { showBtn && <DialogActions>
                { showCancelButton && <Button variant="text" size={buttonSize} color="tertiary" onClick={onClose}>Cancel</Button> }
                <Button size={buttonSize} color="tertiary" onClick={handleCTAClick}>{btnText}</Button>
            </DialogActions>}
        </Dialog>)
}